/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<circle
				opacity="0.4"
				cx="10"
				cy="10"
				r="2"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3 10.349C3 11.3274 3 11.8166 3.11052 12.2769C3.20851 12.6851 3.37012 13.0753 3.58944 13.4331C3.83681 13.8368 4.18271 14.1827 4.87451 14.8745L8.47452 18.4745C10.0586 20.0586 10.8506 20.8506 11.7639 21.1474C12.5673 21.4084 13.4327 21.4084 14.2361 21.1474C15.1494 20.8506 15.9414 20.0586 17.5255 18.4745L18.4745 17.5255C20.0586 15.9414 20.8506 15.1494 21.1474 14.2361C21.4084 13.4327 21.4084 12.5673 21.1474 11.7639C20.8506 10.8506 20.0586 10.0586 18.4745 8.47452L14.8745 4.87452C14.1827 4.18271 13.8368 3.83681 13.4331 3.58944C13.0753 3.37012 12.6851 3.20851 12.2769 3.11052C11.8166 3 11.3274 3 10.349 3H9.4C7.15979 3 6.03968 3 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404C3 6.03968 3 7.15979 3 9.4V10.349Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.4745 8.47452C20.0586 10.0586 20.8506 10.8506 21.1474 11.7639C21.4084 12.5673 21.4084 13.4327 21.1474 14.2361C20.8506 15.1494 20.0586 15.9414 18.4745 17.5255L17.5255 18.4745C15.9414 20.0586 15.1494 20.8506 14.2361 21.1474C13.4327 21.4084 12.5673 21.4084 11.7639 21.1474C10.8506 20.8506 10.0586 20.0586 8.47452 18.4745L4.87452 14.8745C4.18271 14.1827 3.83681 13.8368 3.58944 13.4331C3.37012 13.0753 3.20851 12.6851 3.11052 12.2769C3 11.8166 3 11.3274 3 10.349V9.4C3 7.15979 3 6.03969 3.43597 5.18404C3.81947 4.43139 4.43139 3.81947 5.18404 3.43597C6.03969 3 7.15979 3 9.4 3H10.349C11.3274 3 11.8166 3 12.2769 3.11052C12.6851 3.20851 13.0753 3.37012 13.4331 3.58944C13.8368 3.83681 14.1827 4.18271 14.8745 4.87451L18.4745 8.47452ZM10 12C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8C8.89543 8 8 8.89543 8 10C8 11.1046 8.89543 12 10 12Z"
				fill="currentColor"
			/>
			<path
				d="M3 10.349C3 11.3274 3 11.8166 3.11052 12.2769C3.20851 12.6851 3.37012 13.0753 3.58944 13.4331C3.83681 13.8368 4.18271 14.1827 4.87451 14.8745L8.47452 18.4745C10.0586 20.0586 10.8506 20.8506 11.7639 21.1474C12.5673 21.4084 13.4327 21.4084 14.2361 21.1474C15.1494 20.8506 15.9414 20.0586 17.5255 18.4745L18.4745 17.5255C20.0586 15.9414 20.8506 15.1494 21.1474 14.2361C21.4084 13.4327 21.4084 12.5673 21.1474 11.7639C20.8506 10.8506 20.0586 10.0586 18.4745 8.47452L14.8745 4.87452C14.1827 4.18271 13.8368 3.83681 13.4331 3.58944C13.0753 3.37012 12.6851 3.20851 12.2769 3.11052C11.8166 3 11.3274 3 10.349 3H9.4C7.15979 3 6.03968 3 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404C3 6.03968 3 7.15979 3 9.4V10.349Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10C8 8.89543 8.89543 8 10 8C11.1046 8 12 8.89543 12 10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.12449 15.1852C3.43268 14.4934 3.08678 14.1475 2.83941 13.7438C2.62009 13.3859 2.45848 12.9957 2.36049 12.5876C2.24997 12.1272 2.24997 11.6381 2.24997 10.6597V8.65C2.24997 6.40979 2.24997 5.28969 2.68594 4.43404C3.06944 3.68139 3.68136 3.06947 4.43401 2.68597C5.28965 2.25 6.40976 2.25 8.64997 2.25H10.6597C11.638 2.25 12.1272 2.25 12.5876 2.36052C12.9957 2.45851 13.3859 2.62012 13.7438 2.83944C14.1474 3.08681 14.4933 3.43271 15.1851 4.12452L18.5303 7.46967C20.3911 9.33049 21.3215 10.2609 21.6995 11.3219C22.0862 12.4072 22.0862 13.5928 21.6995 14.6781C21.3215 15.7391 20.3911 16.6695 18.5303 18.5303C16.6695 20.3911 15.7391 21.3216 14.6781 21.6996C13.5928 22.0863 12.4072 22.0863 11.3219 21.6996C10.2609 21.3216 9.33046 20.3911 7.46964 18.5303L4.12449 15.1852ZM9.99997 12C11.1045 12 12 11.1046 12 10C12 8.89543 11.1045 8 9.99997 8C8.8954 8 7.99997 8.89543 7.99997 10C7.99997 11.1046 8.8954 12 9.99997 12Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M16 6L15.5 5.50001L14.8745 4.87452C14.1827 4.18271 13.8368 3.83681 13.4331 3.58944C13.0753 3.37012 12.6851 3.20851 12.2769 3.11052C11.8166 3 11.3274 3 10.349 3H9.4C7.15979 3 6.03968 3 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404C3 6.03968 3 7.15979 3 9.4V10.349C3 11.3274 3 11.8166 3.11052 12.2769C3.20851 12.6851 3.37012 13.0753 3.58944 13.4331C3.83681 13.8368 4.18271 14.1827 4.87451 14.8745L8.47452 18.4745C10.0586 20.0586 10.8506 20.8506 11.7639 21.1474C12.5673 21.4084 13.4327 21.4084 14.2361 21.1474C15.1494 20.8506 15.9414 20.0586 17.5255 18.4745L19 17C20.0905 15.9095 20.6357 15.3643 20.9272 14.7761C21.4818 13.657 21.4818 12.343 20.9272 11.2239C20.6357 10.6357 20.0905 10.0905 19 9.00001V9.00001L18.5 8.5M12 10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10C8 8.89543 8.89543 8 10 8C11.1046 8 12 8.89543 12 10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3 10.349C3 11.3274 3 11.8166 3.11052 12.2769C3.20851 12.6851 3.37012 13.0753 3.58944 13.4331C3.83681 13.8368 4.18271 14.1827 4.87451 14.8745L8.47452 18.4745C10.0586 20.0586 10.8506 20.8506 11.7639 21.1474C12.5673 21.4084 13.4327 21.4084 14.2361 21.1474C15.1494 20.8506 15.9414 20.0586 17.5255 18.4745L18.4745 17.5255C20.0586 15.9414 20.8506 15.1494 21.1474 14.2361C21.4084 13.4327 21.4084 12.5673 21.1474 11.7639C20.8506 10.8506 20.0586 10.0586 18.4745 8.47452L14.8745 4.87452C14.1827 4.18271 13.8368 3.83681 13.4331 3.58944C13.0753 3.37012 12.6851 3.20851 12.2769 3.11052C11.8166 3 11.3274 3 10.349 3H9.4C7.15979 3 6.03968 3 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404C3 6.03968 3 7.15979 3 9.4V10.349Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M12 10C12 11.1046 11.1046 12 10 12C8.89543 12 8 11.1046 8 10C8 8.89543 8.89543 8 10 8C11.1046 8 12 8.89543 12 10Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.12452 15.1852C3.43271 14.4934 3.08681 14.1475 2.83944 13.7438C2.62012 13.3859 2.45851 12.9957 2.36052 12.5876C2.25 12.1272 2.25 11.6381 2.25 10.6597V8.65C2.25 6.40979 2.25 5.28969 2.68597 4.43404C3.06947 3.68139 3.68139 3.06947 4.43404 2.68597C5.28969 2.25 6.40979 2.25 8.65 2.25H10.6597C11.6381 2.25 12.1272 2.25 12.5876 2.36052C12.9957 2.45851 13.3859 2.62012 13.7438 2.83944C14.1475 3.08681 14.4934 3.43271 15.1852 4.12452L18.5303 7.46967C20.3911 9.33049 21.3216 10.2609 21.6996 11.3219C22.0863 12.4072 22.0863 13.5928 21.6996 14.6781C21.3216 15.7391 20.3911 16.6695 18.5303 18.5303C16.6695 20.3911 15.7391 21.3216 14.6781 21.6996C13.5928 22.0863 12.4072 22.0863 11.3219 21.6996C10.2609 21.3216 9.33049 20.3911 7.46967 18.5303L4.12452 15.1852Z"
				fill="currentColor"
			/>
			<path
				d="M10 12C11.1046 12 12 11.1046 12 10C12 8.89543 11.1046 8 10 8C8.89543 8 8 8.89543 8 10C8 11.1046 8.89543 12 10 12Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
